import {useRouteMatch} from 'react-router-dom'

import {PathParams} from '../../definitions/routeTypes'
import {PLANTS_HOME_PATH} from '../../routes'

export function usePlantParameter(): string {
  const match = useRouteMatch<Pick<PathParams, 'plant'>>(PLANTS_HOME_PATH)
  return decodeURIComponent(match?.params.plant ?? '')
}
